<template>
	<!-- 砂浆罐管理 -->
	<div class="saleCustomerManagement">
		<div class="public_Spacing customerManagementPC">

			<div class="customerManagementPC-table pulbic_oparetionBlock pulbic_table_container">

				<div class="progress-bar">
					<div style="text-align: right;" @click="pageMaterialList()">
						<button class="public_saleWater_shuaxin pulic_cursor"><i data-v-318db380=""
								class="iconfont icon-shuaxin1"></i>刷新</button>
					</div>
					<el-row :gutter="20">
						<el-col v-for="item in materList" :span="4">
							<div class="grid-content bg-purple" style="padding-bottom: 20px;">
								<div style="text-align: center; display: flex;">
									<span v-if="item.ORMTB700CA05 =='0'" class="lx"></span>
									<span v-if="item.ORMTB700CA05 =='1'" class="zx"></span>
									
									<el-tooltip placement="top" :content="item.ORMTB700CA06">
										<span class="ellipsis"
											style="padding-left: 10px;">使用地：{{item.ORMTB700CA06||'暂无'}}</span>
									</el-tooltip>

								</div>
								<div class="progress-bg">
									<!-- <img src="../../assets/images/home/sjg.png" class="sjg-img">
									</img> -->
									<!-- <el-progress :text-inside="true" :stroke-width="26" :percentage="70"></el-progress> -->
									<div style="padding-top: 25px;">
										<span style="font-size: 20px;">{{item.ORMTB700CA01}}KG</span>
									</div>
									<div v-if="item.ORMTB700CA01>0" class="progress-fill circle">
										<img :style="{height:item.ORMTB700CA01*0.0018+rlHeight+'px'}" class="lty"
											src="../../assets/images/home/xt.png">
										</img>
									</div>
									<div class="xgBut">
										<el-button class="public_icon_width"
											style="font-size: 18px !important; width: 50px;" type="primary" size="small"
											@click="xgFun(item)">修改</el-button>
									</div>
								</div>


							</div>


						</el-col>
					</el-row>
				</div>
			</div>

			<div class="public-dialog">
				<el-dialog title="修改使用地" :visible.sync="xgtk" @close="detailsList=''" width="30%"
					:closeOnClickModal='false' append-to-body custom-class="mortar-tank-dialog">
					<div class="DetailsWater-Dialog">
						<div class="DWD-li">
							<div class="DWD-li-title">使用地</div>
							<div class="DWD-li-text">{{detailsList.ORMTB700CA06||''}}</div>
						</div>
						<div class="DWD-li">
							<div class="DWD-li-title">修改使用地</div>
							<div class="DWD-li-text">
								<input type="text" v-model="name">

							</div>
						</div>

					</div>
					<div style="margin-top: 20px;text-align: center;">
						<el-button type="primary" @click="xgsave">保存</el-button>
						<el-button type="danger" @click="xgtk=false">取消</el-button>
					</div>
				</el-dialog>
			</div>

		</div>
	</div>
</template>

<script>
	// import {
	// 	Decimal
	// } from 'decimal.js';
	export default {
		data() {
			return {
				row: {},
				page: 1,
				pagesize: 10,
				currentPage: 1,
				userobj: {},
				materList: [],
				xgtk: false,
				detailsList: '',
				name: '',
				listTick: null, // 列表刷新定时器
				rlHeight: 10,
				rowSelectFlag: false // 禁止toggleRowSelection默认触发  @selection-change


			};
		},
		created() {
			var list = "";
			if (this.$route.query.mark != "" && this.$route.query.mark != null) {
				this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
				list = JSON.parse(sessionStorage.getItem("qpSolelist"));
				sessionStorage.removeItem('qpUobj');
				sessionStorage.removeItem('qpSolelist');
				this.quanpDisabled = true;
			} else {
				this.userobj = this.$store.state.uobj;
				console.log(this.userobj)
				list = this.$store.state.solelist;
				this.quanpDisabled = false;
			}
			var path = this.$route.path;
			if (path === "/mortarTank") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			// console.log(this.solelist)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			// sessionStorage.removeItem(this.currentUrl);
			// if (this.historyInfo != null && this.historyInfo != "") {
			// 	this.init();
			// }




		},
		mounted() {
			this.pageMaterialList()
			this.startListTimer()
			// this.querycusList()
			// this.querypreferentialCode()
			// this.khdjFun()

		},
		activated() {
			this.startListTimer()
		},
		deactivated() {
			this.stopListTimer()
		},
		// 存储数据
		beforeDestroy() {
			this.stopListTimer()
			clearInterval(this.listTick)
			this.listTick = null
		},
		methods: {

			startListTimer() {
				if (this.listTick) return
				this.listTick = setInterval(() => {
					if (document.hidden) return
					this.pageMaterialList()
				}, 1000 * 60)
			},
			stopListTimer() {
				if (!this.listTick) return
				clearInterval(this.listTick)
				this.listTick = null
			},
			// 列表
			pageMaterialList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB109CA03: this.categoryMaterial, //物料类别
					// SETTB109CA00: this.nameMaterial, //物料名称
					// // SETTB109CD01: this.cjmsgobj.SETTB414CA01, //一级企业id
					// SETTB99ID: this.cjmsgobj.SETTB414CA01, //二级企业ID
					// ORMTB410ID: this.rowkhId,
					// // ORMTB401CA01: this.materiaShowZJ, //企业是绑定还是自建
					// page: this.pageMaterial,
					// limit: this.limitMaterial
				}
				this.materList = [];
				var moList;
				var url = "/ormtb700/selectList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {

						console.log(res)

						this.materList = res.data.data;

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			xgFun(row) {
				this.detailsList = row;
				console.log(this.detailsList)
				this.xgtk = true;

			},
			xgsave() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB700ID: this.detailsList.ORMTB700ID, //ID
					ORMTB700CA06: this.name
				}

				var url = "/ormtb700/update";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						this.xgtk = false;
						this.pageMaterialList()
						this.$message({
							message: res.data.message,
							type: 'success'
						});

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			handleSizeChangeMaterial(val) {
				this.pageMaterial = 1
				this.limitMaterial = val;
				this.pageMaterialList();
			},
			// 点击页码
			handleCurrentChangeMaterial(val) {
				this.pageMaterial = val;
				this.pageMaterialList();
			},


			//初始化数据
			init() {

				this.currentPage = this.historyInfo.currentPage;
				this.page = this.historyInfo.page;
				this.pagesize = this.historyInfo.pagesize;

			},
			fullScreen() {
				//全屏
				var mark = 1;
				sessionStorage.setItem(
					"qpSolelist",
					JSON.stringify(this.$store.state.solelist)
				);
				sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

				let Logistics = this.$router.resolve({
					path: "/SalesCustomer",
					query: {
						mark: mark,
					},
				});
				this.$baseAPI.requestFullScreen(Logistics);
			},




		}
	};
</script>

<style scoped>
	.carDialogTitle {
		font-weight: bold;
		line-height: 60px;
		color: rgb(0, 163, 255);
	}

	.customerManagementPC {
		background-color: #f3f3f3;
	}

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 150px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		font-size: 0.833vw;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.grid-content > div:first-child {
		justify-content: center;
		align-items: center;
	}

	.progress-bg {
		position: relative;
		background-image: url(../../assets/images/home/sjg.png);
		background-size: cover;
		background-repeat: no-repeat;
		height: 200px;
		width: 200px;
		margin: 0 auto;
		text-align: center;
	}

	.progress-fill {
		/* position: absolute;
		left: 103px;
		width: 259px;
		height: 73px;
		top: 76px; */
	}

	.sjg-img {
		width: 50%;
	}

	.circle {
		position: absolute;
		bottom: 59px;
		left: 20px;
		height: 100px;
		width: 243px;
		/* border-radius: 100px; */
		/* background-color: blue; */

	}

	.zx {
		display: inline-block;
		width: 20px;
		height: 20px;
		background-color: aquamarine;
		border-radius: 10px;
	}

	.lx {
		display: inline-block;
		width: 20px;
		height: 20px;
		background-color: #eee;
		border-radius: 10px;
	}

	.lty {
		position: absolute;
		bottom: -7px;
		left: -65px;
		height: 30px;
		width: 295px;
	}

	.xgBut {
		position: absolute;
		right: -30px;
		bottom: 11px;
	}

	.ellipsis {
		width: 200px;
		/* 定义容器宽度 */
		white-space: nowrap;
		/* 确保文本在一行内显示 */
		overflow: hidden;
		/* 隐藏超出容器的内容 */
		text-overflow: ellipsis;
		/* 使用省略号表示被截断的文本 */

		text-align: center;
	}
</style>
<style>
.mortar-tank-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.mortar-tank-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.mortar-tank-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.mortar-tank-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.mortar-tank-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
